module.exports = __webpack_public_path__ + "media/country_flags/za-1eca44ba.png";